define((require) => {
    "use strict";

    const FontIntegrationModel = require("editor/ui/settings/integrations/FontIntegrationModel");

    /**
     * Custom Font integration model.
     *
     * @class CustomFontIntegration
     */
    return FontIntegrationModel.extend("CustomFontIntegration", {

    }, {
        type: "CustomFontIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/CustomFontIntegrationModel.js